export const pipe = <T>(value: T) => {
  class Pipe<T> {
    constructor(private value: T) {}

    and<P>(calculator: (value: T) => P) {
      return new Pipe(calculator(this.value))
    }

    on<P, B extends boolean>(condition: B, calculator: (value: T) => P): B extends false ? Pipe<T> : Pipe<P> {
      if (condition) return this.and(calculator) as B extends false ? Pipe<T> : Pipe<P>
      return this as unknown as B extends false ? Pipe<T> : Pipe<P>
    }

    get() {
      return this.value
    }
  }

  return new Pipe<T>(value)
}
